/*
 * API
 */
export const apiBase = '/api';

const urls = {
  securityAccess: {
    keepalive: 'keepalive',
    authVerifier: 'auth/verifier',
    userInfo: 'auth/userInfo',
    auth: 'authentication',
    logout: '/saml/logout',
  },
  config: 'configuration',
  users: 'users',
  profiles: 'profiles',
  documents: 'documents',
  regions: 'regions',
  adminRegions: 'admin/regions',
  agencies: 'agencies',
  adminAgencies: 'admin/agencies',
  functions: 'functions',
  categories: 'categories',
  news: 'news',
  functionGroups: 'function-groups',
  userGroups: 'user-groups',
  roadmap: 'roadmap',
  links: 'links',
};
export default urls;



// WEBPACK FOOTER //
// ./shared/src/rest/restConstants.js